import { useState } from "react";
import {
  LayoutDashboard,
  Boxes,
  ArrowLeftRight,
  AlertTriangle,
  BookOpen,
  ClipboardList,
  Send,
  Layers,
  FlaskConical,
  Trash2,
  ShoppingBag,
  UserRound,
  FileText,
  Percent,
  CreditCard,
  CalendarCheck,
  Wallet,
  Receipt,
  Store,
  Scale,
  HandCoins,
  KeyRound,
  GitBranch,
  LineChart,
  TrendingUp,
  BarChart,
  Gauge,
  ChevronLeft,
  Truck,
  GitBranchPlusIcon,
  UtensilsCrossed,
  PlusSquare,
  ReceiptText,
  TruckIcon,
  ContactRound,
  Table,
  PaintRoller,
  KeyIcon,
} from "lucide-react";

import logo from "../../assets/images/logo.png";
import { NavLink } from "react-router-dom";

const modules = [
  {
    title: "Core",
    items: [
      {
        label: "Dashboard",
        icon: LayoutDashboard,
        path: "/admindashboard",
      },
    ],
  },
  {
    title: "Vendors",
    items: [
      {
        label: "Vendors List",
        icon: Store,
        path: "/admindashboard/vendors",
        permission: "vendors.view",
      },
      {
        label: "Purchase Order",
        icon: ClipboardList,
        path: "/admindashboard/poc",
        permission: "purchase_orders.create",
      },
      {
        label: "Vendors Quotations",
        icon: Scale,
        path: "/admindashboard/vendors/quotationscompare",
        permission: "vendor_quotations.view",
      },
      {
        label: "PO Tracking",
        icon: TruckIcon,
        path: "/admindashboard/po/tracking",
        permission: "po.tracking",
      },
      {
        label: "Vendor Payments",
        icon: HandCoins,
        path: "/admindashboard/vendors/commissions",
        permission: "vendor_payments.manage",
      },
    ],
  },
  {
    title: "Inventory",
    items: [
      {
        label: "View Inventory",
        icon: Boxes,
        path: "/admindashboard/inventory",
        permission: "inventory.view",
      },
      {
        label: "Inward / Outward",
        icon: ArrowLeftRight,
        path: "/admindashboard/inventory/inward-history",
        permission: "inventory.movement",
      },
      {
        label: "Stock Alerts",
        icon: AlertTriangle,
        path: "/admindashboard/inventory/alerts",
        permission: "inventory.alerts",
      },
    ],
  },
  {
    title: "Production",
    items: [
      {
        label: "Recipes",
        icon: BookOpen,
        path: "/admindashboard/production/recipes",
        permission: "production.recipes",
      },
      {
        label: "Batches",
        icon: Layers,
        path: "/admindashboard/production/batches",
        permission: "production.batches",
      },
      {
        label: "Raw Usage",
        icon: FlaskConical,
        path: "/admindashboard/production/materials",
        permission: "production.raw_usage",
      },
      {
        label: "Waste",
        icon: Trash2,
        path: "/admindashboard/production/waste",
        permission: "production.waste",
      },
    ],
  },
  {
    title: "Branches",
    items: [
      {
        label: "Branches",
        icon: GitBranch,
        path: "/admindashboard/branches",
        permission: "branches.view",
      },
      {
        label: "Counters",
        icon: Table,
        path: "/admindashboard/counters",
        permission: "counters.view",
      },
      {
        label: "Branch Demands",
        icon: GitBranchPlusIcon,
        path: "/admindashboard/branches/demands",
        permission: "branches.demands",
      },
      {
        label: "Stock Transfer",
        icon: Truck,
        path: "/admindashboard/branches/stocktransfer",
        permission: "branches.transfer",
      },
      {
        label: "Reports",
        icon: LineChart,
        path: "/admindashboard/branches/reports",
        permission: "branches.reports",
      },
    ],
  },
  {
    title: "Menu",
    items: [
      {
        label: "Menu Items",
        icon: UtensilsCrossed,
        path: "/admindashboard/menu-master",
        permission: "menu.view",
      },
      {
        label: "Add Menu Items",
        icon: PlusSquare,
        path: "/admindashboard/menu-master/add",
        permission: "menu.create",
      },
      {
        label: "All Bills",
        icon: ReceiptText,
        path: "/admindashboard/menu-master/bills",
        permission: "menu.bills",
      },
    ],
  },
  {
    title: "Sales & CRM",
    items: [
      {
        label: "Orders",
        icon: ShoppingBag,
        path: "/admindashboard/sales/orders",
        permission: "orders.view",
      },
      {
        label: "Customers",
        icon: UserRound,
        path: "/admindashboard/sales/customers",
        permission: "customers.view",
      },
    ],
  },
  {
    title: "Billing",
    items: [
      {
        label: "Invoices",
        icon: FileText,
        path: "/admindashboard/billing/invoices",
        permission: "invoices.view",
      },
      {
        label: "GST Reports",
        icon: Percent,
        path: "/admindashboard/billing/gst",
        permission: "gst.reports",
      },
      {
        label: "Payments",
        icon: CreditCard,
        path: "/admindashboard/billing/payments",
        permission: "payments.manage",
      },
    ],
  },
  {
    title: "Accounting",
    items: [
      {
        label: "Chart of Accounts",
        icon: BookOpen,
        path: "/admindashboard/accounting/chartofaccounts",
        permission: "accounting.coa",
      },
      {
        label: "Journal Entries",
        icon: FileText,
        path: "/admindashboard/accounting/journal-entries",
        permission: "accounting.journal",
      },
      {
        label: "General Ledger",
        icon: BookOpen,
        path: "/admindashboard/accounting/general-ledger",
        permission: "accounting.ledger",
      },
      {
        label: "Trial Balance",
        icon: Scale,
        path: "/admindashboard/accounting/trial-balance",
        permission: "accounting.trial_balance",
      },
      {
        label: "Profit & Loss",
        icon: TrendingUp,
        path: "/admindashboard/accounting/profit-loss",
        permission: "accounting.profit_loss",
      },
      {
        label: "Balance Sheet",
        icon: BarChart,
        path: "/admindashboard/accounting/balance-sheet",
        permission: "accounting.balance_sheet",
      },
      {
        label: "Cash Book",
        icon: Wallet,
        path: "/admindashboard/accounting/cash-book",
        permission: "accounting.cash_book",
      },
      {
        label: "Bank Book",
        icon: CreditCard,
        path: "/admindashboard/accounting/bank-book",
        permission: "accounting.bank_book",
      },
      {
        label: "Expenses",
        icon: Receipt,
        path: "/admindashboard/accounting/expenses",
        permission: "accounting.expenses",
      },
      {
        label: "Income",
        icon: HandCoins,
        path: "/admindashboard/accounting/income",
        permission: "accounting.income",
      },
    ],
  },
  {
    title: "HR & Payroll",
    items: [
      {
        label: "Attendance",
        icon: CalendarCheck,
        path: "/admindashboard/payroll/attendance",
        permission: "attendance.view",
      },
      {
        label: "Salary",
        icon: Wallet,
        path: "/admindashboard/payroll/salary",
        permission: "salary.manage",
      },
      {
        label: "Payslips",
        icon: Receipt,
        path: "/admindashboard/payroll/payslips",
        permission: "payslips.view",
      },
    ],
  },
  {
    title: "Access Control",
    items: [
      {
        label: "Staff Permissions",
        icon: KeyRound,
        path: "/admindashboard/access/permissions",
        permission: "staff.manage",
      },
      {
        label: "Roles",
        icon: KeyIcon,
        path: "/admindashboard/access/roles",
        permission: "staff.manage",
      },
    ],
  },
  {
    title: "Reports",
    items: [
      {
        label: "Sales Reports",
        icon: TrendingUp,
        path: "/admindashboard/reports/sales",
        permission: "reports.sales",
      },
      {
        label: "Finance Reports",
        icon: BarChart,
        path: "/admindashboard/reports/finance",
        permission: "reports.finance",
      },
      {
        label: "KPIs",
        icon: Gauge,
        path: "/admindashboard/reports/kpis",
        permission: "reports.kpi",
      },
    ],
  },
];

export default function Sidebar({
  permissions = [],
  role,
  collapsed,
  setCollapsed,
}) {
  const hasAccess = (perm) => {
    if (role === "super_admin") return true;
    return permissions.includes(perm);
  };
  return (
    <aside
      className={`fixed left-0 top-0 z-40 h-screen
      ${collapsed ? "w-20" : "w-72"}
      bg-[#07070b] border-r border-white/10
      transition-all duration-300 flex flex-col`}
    >
      <div className="absolute top-0 left-0 h-full w-[2px] bg-gradient-to-b from-amber-400 via-yellow-500 to-amber-400" />

      <div className="flex items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3 overflow-hidden">
          <img src={logo} className="w-10 h-10 shrink-0" />
          {!collapsed && (
            <div>
              <h2 className="font-serif text-lg">Jaggi Sweets</h2>
              <p className="text-[10px] tracking-[0.3em] text-amber-400">
                EXECUTIVE ERP
              </p>
            </div>
          )}
        </div>

        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 rounded-lg hover:bg-white/10 transition"
        >
          <ChevronLeft
            size={18}
            className={`transition-transform ${collapsed ? "rotate-180" : ""}`}
          />
        </button>
      </div>

      <nav className="flex-1 overflow-y-auto sidebar-scroll scrollbar-hide px-3 space-y-6">
        {modules
          .map((section) => ({
            ...section,
            items: section.items.filter(
              (item) => !item.permission || hasAccess(item.permission),
            ),
          }))
          .filter((section) => section.items.length > 0) // ✅ hide empty sections
          .map((section) => (
            <div key={section.title}>
              {!collapsed && (
                <p className="px-3 mb-2 text-[15px] uppercase tracking-widest text-yellow-400">
                  {section.title}
                </p>
              )}

              <div className="space-y-1">
                {section.items.map((item) => {
                  const Icon = item.icon;

                  return (
                    <NavLink
                      key={item.label}
                      to={item.path}
                      end
                      className={({ isActive }) =>
                        `flex items-center gap-3 px-3 py-2 rounded-xl text-sm transition
    ${
      isActive
        ? "bg-amber-400/20 text-amber-400"
        : "text-gray-400 hover:text-white hover:bg-white/5"
    }`
                      }
                    >
                      <Icon size={18} className="shrink-0" />
                      {!collapsed && <span>{item.label}</span>}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          ))}
      </nav>

      {!collapsed && (
        <div className="px-6 py-4 border-t border-white/10 text-xs text-gray-400">
          © {new Date().getFullYear()} Jaggi Sweets
        </div>
      )}
    </aside>
  );
}
